export default __webpack_public_path__ + "static/media/execute_PP3.047b3d9d.png";